import { postTypeGQLFields, } from '../post-type/postType.fields.js';
import { spaceGQLFields } from '../space/space.fields.js';
const BASIC_SPACE_POST_TYPE_FIELDS = {};
const DEFAULT_SPACE_POST_TYPE_FIELDS = {
    postType: 'basic',
};
const ALL_SPACE_POST_TYPE_FIELDS = {
    postType: 'basic',
    space: 'basic',
};
export function spacePostTypeGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SPACE_POST_TYPE_FIELDS;
    if (!fields || fields === 'default')
        fields = DEFAULT_SPACE_POST_TYPE_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_POST_TYPE_FIELDS;
    return `
    spaceId
    postTypeId
    whoCanPost
    whoCanReact
    whoCanReply
    ${fields.postType
        ? `
      postType {
        ${postTypeGQLFields(fields.postType)}
      }
    `
        : ``}
    ${fields.space
        ? `
      space {
          ${spaceGQLFields(fields.space)}
      }
      `
        : ``}
  `;
}
//# sourceMappingURL=space-post-type.fields.js.map